import React, { Component, Fragment } from 'react'
import i18n from 'i18next'
import DataTable from '../DataTable'
import SearchLayout from '../Layouts/Search'
import { getProductTypes } from '../../utils/helpers'
import Checkbox from '../form/Checkbox'

class EventPicker extends Component {
    columns = [
        {
            key: 'name',
            name: 'Event Name',
        },
        {
            name: '',
            key: 'productId',
            cellClass: 'center overflow',
            dataTransform: (productId) => (
                <div
                    className="survey-btn-wrapper"
                    onClick={(e) => {
                        e.stopPropagation()
                        this.props.dashStore.appStore.goTo('full', `salesIntelligence?productId=${productId}`)
                    }}
                >
                    <i className="fa-regular fa-chart-line" />
                    <i className="fa-regular fa-chevron-right" />
                </div>
            ),
        },
    ]

    constructor(props) {
        super(props)
        const { dashStore } = this.props
        const { products, productMap } = dashStore

        const allProductTypes = [...products.reduce((ps, p) => {
            ps.add(p.productType)
            return ps
        }, new Set())]

        this.productTypeNames = getProductTypes(productMap, true)
            .reduce((pnames, p) => ({ ...pnames, [p.value]: p.label }), {})

        this.state = {
            filteredList: products,
            allProductTypes,
            filterProductTypes: allProductTypes,
        }

        this.searchStore = {
            searchModule: undefined,
            search: this.search,
            resetFilter: this.resetFilter,

        }
    }

    setFilter = ({ value, name }) => {
        const { filterProductTypes } = this.state
        if (filterProductTypes.includes(name)) {
            this.setState({ filterProductTypes: filterProductTypes.filter((v) => v !== name) }, this.search)
        } else {
            this.setState({ filterProductTypes: [...filterProductTypes, name] }, this.search)
        }
    }

    renderFilterOptions = () => {
        const { filterProductTypes, allProductTypes } = this.state
        return (
            <Fragment>
                <br />
                <fieldset className="filter">
                    <legend className="legend-title">
                        Filter
                    </legend>
                    <div>
                        {allProductTypes.map((prodType) => (
                            <Checkbox
                                onBlur={this.setFilter}
                                name={prodType}
                                checked={filterProductTypes.includes(prodType)}
                                label={this.productTypeNames[prodType]}
                            />
                        ))}
                    </div>
                </fieldset>
            </Fragment>
        )
    }

    search = () => {
        const { dashStore } = this.props
        const { searchModule } = this.searchStore
        const { filterProductTypes } = this.state
        const filteredList = dashStore.products.filter((p) => (
            (String(p.productId).includes(searchModule.searchStr)
            || p.name.toLowerCase().includes(searchModule.searchStr.toLowerCase()))
            && filterProductTypes.includes(p.productType)
        ))

        this.setState({
            filteredList,
        })
    }

    resetFilter = () => {
        const { allProductTypes } = this.state
        this.setState({ filterProductTypes: [...allProductTypes] }, this.search)
    }

    select = (e, row) => {
        const { dashStore } = this.props
        const { appStore } = dashStore
        e.stopPropagation()
        appStore.goTo('full', `salesIntelligence?productId=${row}`)
    }

    renderTablePanel = () => {
        const { filteredList } = this.state
        return (
            <div className="search-table">
                <DataTable
                    store={this.state}
                    dataSet={filteredList}
                    rowClick={this.select}
                    inMemory
                    rowId="productId"
                    columns={this.columns}
                    rowStyler={(row, index) => (index % 2 === 0 ? 'even' : 'odd')}
                />
            </div>
        )
    }

    renderGuide = () => {
        const desc = i18n.t('salesInteligence.eventSearchGuide')
        return <div dangerouslySetInnerHTML={{ __html: i18n.t(desc) }} />
    }

    render() {
        const pageTitle = i18n.t('events')

        return (
            <SearchLayout
                pageTitle={pageTitle}
                renderFilterOptions={this.renderFilterOptions}
                renderTablePanel={this.renderTablePanel}
                renderGuide={this.renderGuide}
                searchStore={this.searchStore}
                resetFilter={() => (null)}
            />
        )
    }
}

export default EventPicker
